import http from '@/utils/http';

/**
 * 获取全球游戏异动日报可查询的日期列表
 * @param data - 参数对象
 * @param data.start_date - 开始日期，格式：YYYY-MM-DD（可选）
 * @param data.end_date - 结束日期，格式：YYYY-MM-DD（可选）
 * @returns 可查询的日报日期列表
 */
export const fetchGlobalDynamicsDailyDates = (data?: {
  start_date?: string;
  end_date?: string;
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/report/global_dynamics/daily/date',
    method: 'post',
    data,
    rawData: true,
  }) as Promise<any>;
};

/**
 * 获取指定日期的全球游戏异动日报数据
 * @param data - 参数对象
 * @param data.report_date - 报表日期，格式：YYYY-MM-DD
 * @returns mobile / steam / roblox 三个模块的日报数据
 */
export const fetchGlobalDynamicsDailyData = (data: {
  report_date: string;
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/report/global_dynamics/daily/get_data',
    method: 'post',
    data: { report_date: data.report_date },
    rawData: true,
  }) as Promise<any>;
};
